import React from "react";
import { useHistory } from "react-router-dom";
import theme from "../theme/theme";

import interactiveBroker from "../assets/interactiveBroker.png";

import CardHeader from "../components/CardHeader/CardHeader";
import HeaderWithoutLogin from "../components/HeaderWithoutLogin";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import Card from "../components/Card/Card";

import styled from "styled-components";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 3%;

  .formContainer__header {
    margin-left: 3em;
    max-width: 80%;
  }

  .card_types {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
  }

  button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  .card_size {
    display: flex;
    justify-content: center;
    width: 20em;
    text-align: center;
    color: ${theme.colors.primaryStrong2X};
    font-weight: bold;
    font-size: 18px;
  }

  .otherContainer {
    display: flex;
    width: 200px;
    height: 35px;
    display: flex;
    width: 200px;
    height: 35px;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }

  @media (max-width: 480px) {
    .card_size {
      width: 100%;
      text-align: center;
    }
  }
  @media (max-width: 700px) {
    .card_types {
      display: flex;
      flex-direction: column;
    }
  }
`;

const SelectCustodian = () => {
  const history = useHistory();

  const handleOtherCustodianClick = () => {
    history.push("/select-custodian");
  };

  const handleInteractiveBrokerClick = () => {
    history.push("/select-custodian-type");
  };

  return (
    <>
      <HeaderWithoutLogin isLogOutButtonVisible={false} />
      <BodyWrapper>
        <div className="formContainer">
          <div className="formContainer__header">
            <CardHeader text={"Select Your Custodian"} />
            We use a custodian to manage your investment, whether its
            traditional or crypto currency.
            <div className="card_types">
              <button
                className="card_size"
                onClick={handleInteractiveBrokerClick}
              >
                <Card>
                  <img
                    className="imgContainer"
                    src={interactiveBroker}
                    alt="interactive-broker"
                  />
                </Card>
              </button>
              <button className="card_size" onClick={handleOtherCustodianClick}>
                <Card>
                  <div className="otherContainer">
                    <FontAwesomeIcon icon={faPlusCircle} /> &nbsp;Other
                    Custodian
                  </div>
                </Card>
              </button>
            </div>
          </div>
        </div>
      </BodyWrapper>
    </>
  );
};

export default SelectCustodian;
